var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import Button from '~/components/button';
import GeniusModal from '~/components/genius_modal';
import SelectFolderInput from '~/components/select_folder_input';
import { useToast } from '~/components_to_be_packaged/toast/provider';
import Input from '~/form_components/text_input';
import { useAppSidebar } from '../../../provider';
const AddProjectForm = (props) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedFolder, setSelectedFolder] = useState(null);
    const [folderName, setFolderName] = useState('');
    const { showToast } = useToast();
    const { projectsWorkspaces, createProject, isArchivedVisible } = useAppSidebar();
    const onFolderSelect = (folder) => {
        setSelectedFolder(folder);
        ToggleFolderExpansion();
    };
    const ToggleFolderExpansion = () => {
        setIsExpanded(!isExpanded);
    };
    const onCreateFolder = () => __awaiter(void 0, void 0, void 0, function* () {
        if (folderName && selectedFolder) {
            resetUI();
            props.onHide();
            yield createProject(folderName, selectedFolder.id === 'top-level-option' ? undefined : selectedFolder.id);
            showToast({ description: 'New folder created successfully' });
        }
    });
    const resetUI = () => {
        setSelectedFolder(null);
        setIsExpanded(false);
        setFolderName('');
    };
    return (React.createElement(GeniusModal, { isModalShowing: props.isVisible, alertForm: true, onHide: () => { props.onHide(); resetUI(); }, bodyContent: React.createElement(React.Fragment, null,
            React.createElement("label", { className: 'modal-input-label', htmlFor: 'Folder Name' }, "Folder name"),
            React.createElement("div", { className: 'add-modal-text-input' },
                React.createElement(Input, { name: 'folder name', value: folderName, onChange: (e) => setFolderName(e.target.value), placeholder: 'Enter a folder name' })),
            React.createElement("label", { className: 'modal-input-label', htmlFor: 'Location' }, "Location"),
            React.createElement(SelectFolderInput, { ToggleFolderExpansion: ToggleFolderExpansion, isExpanded: isExpanded, isArchivedVisible: isArchivedVisible, projectsWorkspaces: projectsWorkspaces, onFolderSelect: onFolderSelect, showTopLevelOption: true, selectedId: selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.id, selectedDisplay: selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.name })), footerContent: React.createElement(Button, { className: 'modal-action-btn', primary: true, onClick: onCreateFolder, disabled: !folderName || !selectedFolder }, "Create Folder") }));
};
export default AddProjectForm;
